import React from "react";

type CodeReaderFieldProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  style?: React.CSSProperties;
  UpperCase?: boolean;
  disabled?: boolean;
};

const CodeReaderField: React.FC<CodeReaderFieldProps> = ({
  label = "QR Code",
  value,
  onChange,
  onSubmit,
  placeholder,
  style = {},
  UpperCase = false,
  disabled = false,
}) => {
  const primaryColor = "#0a343c";

  const width = style.width ?? "100%";
  const marginLeft = style.marginLeft ?? 0;
  const marginTop = style.marginTop ?? 18;

  const handleChange = (raw: string) => {
    const nextValue = UpperCase ? raw.toUpperCase() : raw;
    onChange(nextValue);
  };

  const handleSubmit = () => {
    if (disabled) return;
    onSubmit?.();
  };

  return (
    <div
      style={{
        width: "100%",
        marginTop,
        marginLeft,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "stretch",
          width,
          maxWidth: "100%",
          height: 34,
          fontFamily:
            "'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: 88,
            minWidth: 88,
            height: "100%",
            backgroundColor: "#E4E6E8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 11,
            fontWeight: 700,
            color: "#2f3a42",
            border: "1px solid #8A8A8A",
            borderRight: "none",
            boxSizing: "border-box",
            userSelect: "none",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {label || "QR Code"}
        </div>

        <input
          type="text"
          value={UpperCase ? String(value ?? "").toUpperCase() : value}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSubmit();
          }}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            flex: 1,
            minWidth: 0,
            height: "100%",
            borderTop: "1px solid #8A8A8A",
            borderBottom: "1px solid #8A8A8A",
            borderLeft: "none",
            borderRight: "none",
            padding: "0 8px",
            fontSize: 12,
            fontWeight: 500,
            outline: "none",
            boxSizing: "border-box",
            textTransform: UpperCase ? "uppercase" : "none",
            backgroundColor: disabled ? "#F4F5F6" : "#FFFFFF",
            color: "#111827",
            opacity: disabled ? 0.75 : 1,
            fontFamily: "inherit",
          }}
        />

        <button
          type="button"
          onClick={handleSubmit}
          disabled={disabled}
          style={{
            width: 78,
            minWidth: 78,
            height: "100%",
            backgroundColor: disabled ? "#6F7D82" : primaryColor,
            color: "#FFFFFF",
            fontSize: 11.5,
            fontWeight: 700,
            fontFamily: "inherit",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: disabled ? "not-allowed" : "pointer",
            border: `1px solid ${disabled ? "#6F7D82" : primaryColor}`,
            borderLeft: "none",
            borderRadius: 0,
            padding: 0,
            boxSizing: "border-box",
            whiteSpace: "nowrap",
          }}
        >
          Enviar
        </button>
      </div>
    </div>
  );
};

export default CodeReaderField;
